<template>
    <div class="yuji-news" :class="device == 'mobile' ? 'yuji-news-mobile' : ''">
        <div class="news padding-top">
            <div class="main">
                <div class="tags">
                    <a href="/index">首页</a>
                    >
                    <a href="/news">新闻中心</a>
                    >
                    <span>新闻详情</span>
                </div>
                <div class="news-box">
                    <h2 class="title">跨越界限：AI数字人如何帮助克服社交障碍</h2>
                    <div class="time">2024-06-07 11:00:10</div>
                    <div class="start">
                        在数字化时代，人工智能（AI）技术正以前所未有的速度和规模渗透到我们生活的方方面面。AI数字人，作为人工智能领域的一项创新成果，正在帮助人们跨越社交障碍，开辟了一种全新的人际互动方式。


                    </div>
                    <div class="banner">
                        <img src="@/assets/imgs/news/327.png" alt="跨越界限：AI数字人如何帮助克服社交障碍" srcset />
                    </div>
                    <div class="list">
                        <div class="list-t"></div>
                        <div class="list-text">
                            社交障碍通常是指个体在社交场合中感到紧张、焦虑或不自在，这可能源于多种原因，如性格内向、社交恐惧症或缺乏社交技巧。AI数字人通过模拟人类行为和交流模式，为那些在现实生活中面临社交障碍的人提供了一个安全、无压力的交流平台。
                        </div>
                    </div>
                    <div class="list">
                        <div class="list-t"></div>
                        <div class="list-text">
                            首先，AI数字人能够提供一个无评判的环境。它们不会对用户的言行做出负面评价，这使得用户可以自由地表达自己，不必担心被嘲笑或误解。这种积极的反馈循环有助于增强用户的自信心，并逐渐克服社交恐惧。
                        </div>
                    </div>
                    <div class="list">
                        <div class="list-t"></div>
                        <div class="list-text">
                            其次，AI数字人可以作为社交技能训练的辅助工具。它们可以根据用户的需求定制对话场景，帮助用户练习特定的社交技巧，如开场白、维持对话、处理冲突等。通过与AI数字人的互动，用户可以在一个控制良好的环境中逐步提高社交能力。
                        </div>
                    </div>
                    <div class="list">
                        <div class="list-t"></div>
                        <div class="list-text">
                            此外，AI数字人还能帮助用户探索自我。通过与AI的对话，用户可以更好地了解自己的社交偏好、情感反应和行为模式。AI数字人可以提供个性化的建议和反馈，帮助用户认识到自己在社交中的优势和需要改进的地方。
                        </div>
                    </div>
                    <div class="list">
                        <div class="list-t"></div>
                        <div class="list-text">
                            AI数字人还可以用于社交焦虑的治疗。在专业心理医生的指导下，AI数字人可以作为治疗过程中的一个环节，帮助患者逐渐适应社交环境，减轻焦虑感。通过模拟现实生活中的社交场景，AI数字人能够帮助患者逐步建立起面对社交场合的信心。
                        </div>
                    </div>
                    <div class="end">
                        最后，AI数字人还能够跨越语言和文化的界限。它们可以被设计成支持多种语言，帮助不同文化背景的人进行交流，促进跨文化交流和理解。 总之，AI数字人作为一种新兴技术，正在帮助人们以一种全新的方式克服社交障碍。通过提供一个安全、无压力的交流平台，AI数字人不仅能够帮助用户提高社交技巧，还能够促进自我探索和跨文化交流。随着AI技术的不断进步，我们有理由相信，AI数字人将在帮助人们跨越社交障碍方面发挥越来越重要的作用。

                    </div>
                </div>
                <a href="/index" class="btn">
                    了解更多
                    <img src="@/assets/imgs/index/arrow.png" alt />
                </a>
            </div>
        </div>
    </div>
</template>

<script>
import Header from "@/components/header";
import newsData from "@/utils/newJson";
export default {
    components: {
        Header,
    },
    computed: {
        device() {
            return this.$store.state.app.device;
        },
    },
    metaInfo: {
        title: "跨越界限：AI数字人如何帮助克服社交障碍-羽迹美形", // set a title
        meta: [
            {
                // set meta
                name: "keyWords",
                content: "跨越界限：AI数字人如何帮助克服社交障碍,羽迹美形",
            },
            {
                // set meta
                name: "description",
                content:
                    "在数字化时代，人工智能（AI）技术正以前所未有的速度和规模渗透到我们生活的方方面面",
            },
        ],
    },
    data() {
        return {
            path: "newsInfo3",
            obj: {},
        };
    },
    mounted() {
        document.body.scrollTop = document.documentElement.scrollTop = 0;
        var index = this.$route.params.index;
        newsData.forEach((el, i) => {
            if (el.index == index) {
                this.obj = el;
            }
        });
    },
    methods: {
        goback() {
            this.$router.go(-1);
        },
    },
};
</script>


<style lang="scss" scoped>
.yuji-news {
    .news {
        min-width: 720px;

        .main {
            .tags {
                height: 40px;
                line-height: 40px;
                color: #999;
                border-bottom: 1px solid #eee;
                font-size: 14px;

                a {
                    color: #999;
                }
            }

            width: 720px;

            .back {
                height: 50px;
                line-height: 50px;
                position: relative;
                padding-left: 20px;
                cursor: pointer;
                border-bottom: 1px solid #eee;
                width: 720px;
                background: #fff;

                &::before {
                    position: absolute;
                    top: 50%;
                    left: 0;
                    content: "";
                    width: 6px;
                    height: 6px;
                    border-left: 2px solid #666;
                    border-bottom: 2px solid #666;
                    transform: rotate(45deg) translateY(-50%);
                }

                span {
                    color: #666;
                    font-size: 14px;
                }
            }

            .news-box {
                // padding: 100px 0;
                // display: flex;
                // justify-content: center;
                // background: pink;
                padding: 50px 0 100px;

                .title {
                    font-size: 28px;
                    font-weight: 600;
                }

                .time {
                    color: #999;
                }

                .start {
                    font-size: 16px;
                    margin: 20px 0;
                    text-indent: 30px;
                    line-height: 28px;
                }

                .banner {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: 100%;

                    img {
                        width: 100%;
                        max-width: 660px;
                        height: auto;
                    }
                }

                .list {
                    margin: 20px 0;

                    .list-t {
                        font-size: 18px;
                        font-weight: 600;
                        margin: 16px 0;
                    }

                    .list-text {
                        text-indent: 30px;
                        line-height: 28px;
                    }
                }

                .end {
                    text-indent: 30px;
                    margin-top: 50px;
                    line-height: 28px;
                }
            }
        }

        .btn {
            width: 219px;
            height: 61px;
            background: linear-gradient(129deg, #42f1c9 0%, #2bbda0 100%);
            margin: 0 auto 40px;
            border-radius: 31px;
            color: #fff;
            font-weight: 600;
            font-size: 16px;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;

            img {
                margin-left: 10px;
            }
        }
    }

    &-mobile {
        .news {
            min-width: 100%;

            &.padding-top {
                padding-top: 50px;
            }

            .main {
                width: 100%;

                .back {
                    height: 40px;
                    line-height: 40px;
                    padding-left: 20px;
                    cursor: pointer;
                    border-bottom: 1px solid #eee;
                    display: flex;
                    align-items: center;
                    width: 100%;
                    background: #fff;

                    &::before {
                        position: absolute;
                        top: 48%;
                        left: 8px;
                        content: "";
                        width: 6px;
                        height: 6px;
                        border-left: 2px solid #666;
                        border-bottom: 2px solid #666;
                        transform: rotate(45deg) translateY(-50%);
                    }

                    span {
                        color: #666;
                        font-size: 14px;
                    }
                }

                .news-box {
                    // padding: 100px 0;
                    // display: flex;
                    // justify-content: center;
                    // background: pink;
                    padding: 50px 20px 100px;

                    .title {
                        font-size: 24px;
                        font-weight: 600;
                    }

                    .time {
                        color: #999;
                        font-size: 14px;
                    }

                    .start {
                        font-size: 16px;
                        margin: 20px 0;
                        text-indent: 30px;
                        line-height: 28px;
                    }

                    .banner {
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        width: 100%;

                        img {
                            width: 100%;
                        }
                    }

                    .list {
                        margin: 20px 0;

                        .list-t {
                            font-size: 16px;
                            font-weight: 600;
                            margin: 16px 0;
                        }

                        .list-text {
                            text-indent: 30px;
                            line-height: 28px;
                            font-size: 14px;
                        }
                    }

                    .end {
                        text-indent: 30px;
                        margin-top: 50px;
                        line-height: 28px;
                        font-size: 14px;
                    }
                }
            }

            .btn {
                width: 160px;
                height: 40px;
                font-size: 14px;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/views/newsInfo/newsInfo327.vue